import { render, staticRenderFns } from "./offers-wrapper.vue?vue&type=template&id=10e0d89a&"
import script from "./offers-wrapper.vue?vue&type=script&lang=js&"
export * from "./offers-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports